export default {
  visible: 'visible',
  open: { $call: 'open' },
  close: { $call: 'close' },
  toggle: { $call: 'toggle' },
  onDone: { $call: 'done' },
};
